import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class NoCurrentChats extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="chat d-flex align-items-center justify-content-center">
                    <div className="status-right">
                        <div className="audio-chat">
                            <div className="avatar mr-0">
                                <div className="letter-avatar left-menu-avatar">
                                    {this.props.chatprop.operator.first_letter}
                                </div>
                            </div>
                            <p>Hey, <span className="no-current-chat-title"> {this.props.chatprop.operator.first_last_name}!</span></p>
                            <p className="no-current-chat-description">
                                {this.props.description}
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )

    }
}

export default withTranslation()(NoCurrentChats);




